(function () {
  document.addEventListener('copy', function (event) {
    var selection = window.getSelection && window.getSelection();
    var text = selection ? selection.toString().trim() : '';
    if (!text || text.length < 24) return;
    var active = document.activeElement;
    if (active && /^(INPUT|TEXTAREA|SELECT)$/i.test(active.tagName)) return;
    var source = window.location.href.split('#')[0];
    var next = text + '\n\nFuente: ' + source;
    if (!event.clipboardData) return;
    event.clipboardData.setData('text/plain', next);
    event.preventDefault();
  });
})();
